// extracted by mini-css-extract-plugin
export var locationCard = "_et-0";